import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Bell, AlertTriangle, Info } from 'lucide-react';

export function InjectNotificationModal({ open, onAcknowledge, notification }) {
  if (!notification) return null;

  const getPriorityIcon = (priority) => {
    switch (priority) {
      case 'high':
        return <AlertTriangle className="w-6 h-6 text-red-500" />;
      case 'medium':
        return <Bell className="w-6 h-6 text-yellow-500" />;
      default:
        return <Info className="w-6 h-6 text-blue-500" />;
    }
  };

  const getPriorityClass = (priority) => {
    switch (priority) {
      case 'high':
        return 'bg-red-500/10 border-red-500/30 text-red-500';
      case 'medium':
        return 'bg-yellow-500/10 border-yellow-500/30 text-yellow-500';
      default:
        return 'bg-blue-500/10 border-blue-500/30 text-blue-500';
    }
  };

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent 
        className="max-w-md w-[95vw] max-h-[90vh] overflow-y-auto"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <div className="flex items-center gap-3">
            {getPriorityIcon(notification.priority)}
            <div>
              <DialogTitle className="font-secondary text-lg">
                New Inject Triggered
              </DialogTitle>
              <DialogDescription>
                {notification.exercise_name && `Exercise: ${notification.exercise_name}`}
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="p-4 rounded-lg border bg-muted/50 max-h-[45vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-2">
              <h3 className="font-semibold text-base">
                {notification.inject_title || 'New Inject'}
              </h3>
              {notification.priority && (
                <Badge className={`${getPriorityClass(notification.priority)} capitalize`}>
                  {notification.priority}
                </Badge>
              )}
            </div>
            {notification.inject_content && (
              <p className="text-sm text-muted-foreground whitespace-pre-wrap">
                {notification.inject_content}
              </p>
            )}
          </div>

          <p className="text-sm text-muted-foreground text-center">
            You must acknowledge this inject to continue.
          </p>
        </div>

        <DialogFooter>
          <Button 
            onClick={onAcknowledge}
            className="w-full"
            data-testid="acknowledge-inject-btn"
          >
            <Bell className="w-4 h-4 mr-2" />
            Acknowledge
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default InjectNotificationModal;
